<template>
    <div class="container-fluid">
        <div class="row" v-if="isIncomeValidData">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="pull-left">
                            <h4 class="card-title float-left">{{$t('newRealEstate.income.title')}}</h4>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 table-responsive">
                                <template v-if="isRentComparison">
                                    <span><b> Ижара нархи:  {{realEstate.comparisonNewIncome.incomeRent.total | currency('', 2, { thousandsSeparator: ' ' })}} сўм </b></span>
                                    <div class="pull-right">
                                        <button class="all-btn add-btn btn-sm" @click="showIncomeRentComparisonModal">Ижара калкулацияси</button>
                                    </div>
                                </template>
                                <template v-else-if="!isOwnerTypePhysical">
                                    <div class="table-wrapper">
                                      <table class="table table-sm table-striped comparison-table" style="min-width: 900px">
                                          <tr>
                                              <th class="text-center" colspan="2">{{$t('newRealEstate.income.rentTitle')}}</th>
                                          </tr>
                                          <tr>
                                              <th class="text-center" rowspan="2" width="50%">Кўрсаткичлар</th>
                                              <th class="text-center">Ижарага берилган йиллар</th>
                                          </tr>
                                          <tr>
                                              <th class="text-center">1 йили</th>
                                          </tr>
                                          <tr class="section-start">
                                              <th class="text-center">1</th>
                                              <th class="text-center">2</th>
                                          </tr>
                                          <tr>
                                              <td>Объект номи</td>
                                              <td class="text-center">Бино ва иншоотлар</td>
                                          </tr>
                                          <tr>
                                              <td>Ижарага бериш майдони кв.м <span class="red">*</span></td>
                                              <td class="text-center">{{realEstate.comparisonNewIncome.rentArea}}</td>
                                          </tr>
                                          <tr>
                                              <td>Фаолият тури ўзгариши</td>
                                              <td class="text-center">Ўзгармаган</td>
                                          </tr>
                                          <tr class="section-start">
                                              <td>{{$t('newRealEstate.income.valEs')}}</td>
                                              <td class="text-center">{{realEstate.comparisonNewIncome.minRateForOneAreaToOneYear}}</td>
                                          </tr>
                                          <tr>
                                              <td>Бир йилга бир кв. метр учун энг кам ставка</td>
                                              <td class="text-center">{{realEstate.comparisonNewIncome.minRateForAllAreaToOneYear}}</td>
                                          </tr>
                                          <tr class="section-start">
                                              <td :colspan="2" class="text-center">Киритилган тузатишлар ва уларнинг мохияти</td>
                                          </tr>
                                          <tr class="section-start">
                                              <td>Ҳудудий зоналар учун (Кз):</td>
                                              <td class="text-center"> {{realEstate.comparisonNewIncome.zone}} - зона</td>
                                          </tr>
                                          <tr>
                                              <td><i>Тузатишлар</i></td>
                                              <td class="text-center">{{realEstate.comparisonNewIncome.fixTerritorialZones}}</td>
                                          </tr>
                                          <tr class="section-start">
                                              <td>{{$t('newRealEstate.income.valKk')}} <span class="red">*</span></td>
                                              <td class="text-center">{{realEstate.comparisonNewIncome.coefficientOfConstruction.name}}</td>
                                          </tr>
                                          <tr>
                                              <td><i>Тузатишлар</i></td>
                                              <td class="text-center">{{realEstate.comparisonNewIncome.fixCoefficientOfConstruction}}</td>
                                          </tr>
                                          <tr class="section-start">
                                              <td>{{$t('newRealEstate.income.valKh')}} <span class="red">*</span></td>
                                              <td class="text-center">{{realEstate.comparisonNewIncome.coefficientOfConnectedArea.name}}</td>
                                          </tr>
                                          <tr>
                                              <td><i>Тузатишлар</i></td>
                                              <td class="text-center">{{realEstate.comparisonNewIncome.fixCoefficientOfConnectedArea}}</td>
                                          </tr>
                                          <tr class="section-start">
                                              <td>{{$t('newRealEstate.income.valKt')}} <span class="red">*</span></td>
                                              <td class="text-center">{{realEstate.comparisonNewIncome.coefficientOfCommercialGoal.name}}</td>
                                          </tr>
                                          <tr>
                                              <td><i>Тузатишлар</i></td>
                                              <td class="text-center">{{realEstate.comparisonNewIncome.fixCoefficientOfCommercialGoal}}</td>
                                          </tr>
                                          <tr class="section-start">
                                              <td>{{$t('newRealEstate.income.valTs')}}</td>
                                              <td class="text-center"><b>{{realEstate.comparisonNewIncome.calculated.rentPricePerM2PerYear | currency('', 2, { thousandsSeparator: ' ' })}}</b></td>
                                          </tr>
                                      </table>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="table-wrapper">
                                      <table class="table table-sm table-striped comparison-table" style="min-width: 900px">
                                          <tr>
                                              <th class="text-center" colspan="2">{{$t('newRealEstate.income.rentTitle')}}</th>
                                          </tr>
                                          <tr>
                                              <th class="text-center" rowspan="2" width="50%">Кўрсаткичлар</th>
                                              <th class="text-center">Ижарага берилган йиллар</th>
                                          </tr>
                                          <tr>
                                              <th class="text-center">1 йили</th>
                                          </tr>
                                          <tr class="section-start">
                                              <th class="text-center">1</th>
                                              <th class="text-center">2</th>
                                          </tr>
                                          <tr>
                                              <td>Объект номи</td>
                                              <td class="text-center">Бино ва иншоотлар</td>
                                          </tr>
                                          <tr>
                                              <td>Ижарага бериш майдони кв.м <span class="red">*</span></td>
                                              <td class="text-center">{{realEstate.comparisonNewIncome.rentArea}}</td>
                                          </tr>
                                          <tr>
                                              <td>Жисмоний шахслар учун белгиланган ижара тўловининг энг кам ставка(1 кв. метр учун)
                                              </td>
                                              <td class="text-center">{{realEstate.comparisonNewIncome.individualRentAmount / 12}}</td>
                                          </tr>
                                          <tr class="section-start">
                                              <td>Бир йилга бир кв. метр учун энг кам ставка</td>
                                              <td class="text-center">{{realEstate.comparisonNewIncome.individualRentAmount}}</td>
                                          </tr>
                                      </table>
                                    </div>
                                </template>
                            </div>

                            <div class="col-12 table-responsive">
                                <div class="table-wrapper">
                                  <table class="table table-striped comparison-table mb-3" style="min-width: 900px">
                                      <tr>
                                          <th rowspan="2" class="text-center">Кўрсаткичлар</th>
                                          <th v-if="realEstate.comparisonNewIncome.analogs.length > 0" :colspan="realEstate.comparisonNewIncome.analogs.length" class="text-center">
                                              Аналоглар
                                          </th>
                                      </tr>
                                      <tr>
                                          <th class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.source}}
                                              <br />
                                              <a :href="`https://e-rieltor.uz/products/product/${analog.id}`" target="_blank">https://e-rieltor.uz/products/product/{{analog.id}}</a>
                                          </th>
                                      </tr>
                                      <tr>
                                          <td>бозор қиймати(сўм)</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.price | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr v-if="realEstate.buildingType !== 'RESIDENTIAL_MULTI_STOREY'">
                                          <td>Умумий ер майдони(м2)</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.area | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Умумий майдони(м2)</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.usefulArea | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>1 м2 учун нарх</td>
                                          <td v-for="(analog,index) in realEstate.comparisonNewIncome.analogs" :key="index" class="text-right">
                                              {{analog.perAreaPrice | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Йиллик ижара ставкаси 1кв.м(сўм)</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.calculated.rentPricePerM2PerYear | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Ялпи даромад(сўм)</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.calculated.grossIncome | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Юклаш қоффиценти</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.coefficient.incomeLoad | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Хақиқий даромад(сўм)</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.calculated.realIncome | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr class="section-start">
                                          <td colspan="4" class="text-center">Шартли ўзгармас харажатлар</td>
                                      </tr>
                                      <tr>
                                          <td>Мулк солиги (фоизда)</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.coefficient.propertyTax | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Мулк солиги қиймати (сўм)</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.calculated.propertyTaxAmount | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Ер солиғи</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.calculated.landTaxAmount | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Суғурталаш харажатлари (фоизда)</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.coefficient.insurance | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Суғурталаш харажатлари қиймати (сўм)</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.calculated.insurance | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td style="font-weight: bold; color: #404040;">Жами шартли ўзгармас харажатлар қиймати</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{(analog.totalFixedCost) | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr class="section-start">
                                          <td colspan="4" class="text-center">Шартли узгарувчан харажатлар шу жумладан:</td>
                                      </tr>
                                      <tr>
                                          <td>Бошқарув харажатлари</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.coefficient.managementCosts | currency('', 2, { thousandsSeparator: ' ' })}} %
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>бошқарув харажатлари қиймати (сўм)</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.calculated.managementCostsAmount | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Коммунал харажатлар (сўм)</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.calculated.utilityCosts | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Ҳудудни сақлаш харажатлари</td>
                                          <td class="text-center" rowspan="3" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.coefficient.expenseOthers}} %
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>жорий таъмирлаш ишлари учун харажатлар;</td>
                                      </tr>
                                      <tr>
                                          <td>Алмаштириш харажатлари.</td>
                                      </tr>
                                      <tr>
                                          <td><b>Жами </b>(худудни сақлаш, жорий таъмирлаш ишлари учун ва алмаштириш харажатлари сўм да)</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.calculated.expenseOthersAmount | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Хизмат кўрсатувчи ходимлар иш ҳақи ва унга солинадиган солиқлар;</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.coefficient.salaryTaxes }} %
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Жами</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.calculated.salaryTaxesAmount | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Бошқа турдаги харажатлар</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              5%
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Бошқа турдаги харажатлар(сўм)</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.calculated.securityCostsAmount | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Жами шартли узгарувчи харажатлар(сўм)</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.totalVariableCost | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr class="section-start">
                                          <td>Жами харажатлар(сўм)</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{analog.totalCosts | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr class="section-start">
                                          <td>СОД(сўм)</td>
                                          <td class="text-center" v-for="(analog, index) in realEstate.comparisonNewIncome.analogs" :key="index" style="position: relative">
                                              {{(analog.calculated.realIncome - analog.totalCosts) | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr class="section-start">
                                          <td>СОД ўртача(сўм)</td>
                                          <td class="text-center" style="position: relative" colspan="3">
                                              {{(averageAnalogNetIncome / 3) | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                  </table>
                                </div>
                            </div>

                            <div class="col-12 table-responsive">
                                <div class="table-wrapper">
                                  <table class="table table-striped comparison-table mb-0" style="min-width: 900px">
                                      <tr>
                                          <th colspan="3" class="text-center">Объектнинг даромад усулида бахолаш кийматини хисоб - китоби</th>
                                      </tr>
                                      <tr class="section-start">
                                          <td colspan="3" class="text-center">Бахоланаётган обеъкт</td>
                                      </tr>
                                      <tr>
                                          <td width="76%">Бозор қиймат</td>
                                          <td width="13%" class="text-right">{{realEstate.comparisonNewIncome.calculated.cadastreBalance | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td width="11%">сум</td>
                                      </tr>
                                  </table>
                                </div>
                                <div class="table-wrapper">
                                  <table class="table table-sm table-striped comparison-table mb-0 no-border-top" style="min-width: 900px">
                                      <tr class="section-start">
                                          <td colspan="7" class="text-center">Даромадлар таҳлили</td>
                                      </tr>
                                      <tr class="bold-row">
                                          <td width="25%">Бино тури</td>
                                          <td width="11%" class="text-center">Объектнинг Фойдали майдони м2</td>
                                          <td width="11%" class="text-center">Умумий ер майдони м2</td>
                                          <td width="11%" class="text-center">1м2 бериладиган ижара суммаси 1-йилга</td>
                                          <td width="11%" class="text-center">Ялпи даромад(сўм)</td>
                                          <td width="13%" class="text-center">Юклаш Коэффициенти</td>
                                          <td width="11%" class="text-center">Хакикий даромад</td>
                                      </tr>
                                      <tr>
                                          <td>Бино ва иншоотлар</td>
                                          <td class="text-right">{{realEstate.comparisonNewIncome.rentArea}}</td>
                                          <td class="text-right">{{realEstate.comparisonNewIncome.area}}</td>
                                          <td class="text-right">{{realEstate.comparisonNewIncome.calculated.rentPricePerM2PerYear | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td class="text-right">{{realEstate.comparisonNewIncome.calculated.grossIncome | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td class="text-right">{{realEstate.comparisonNewIncome.coefficient.incomeLoad}}</td>
                                          <td class="text-right">{{realEstate.comparisonNewIncome.calculated.realIncome | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                      </tr>
                                  </table>
                                </div>
                                <div class="table-wrapper">
                                  <table class="table table-sm table-striped comparison-table mb-0 no-border-top" style="min-width: 900px">
                                      <tr class="section-start">
                                          <td colspan="4" class="text-center">Шартли ўзгармас харажатлар</td>
                                      </tr>
                                      <tr>
                                          <td>Мулк солиги</td>
                                          <td>{{realEstate.comparisonNewIncome.coefficient.propertyTax}} %</td>
                                          <td class="text-right">{{realEstate.comparisonNewIncome.calculated.propertyTaxAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сўм</td>
                                      </tr>
                                      <tr>
                                          <td>Ер солиғи</td>
                                          <td></td>
                                          <td class="text-right">{{realEstate.comparisonNewIncome.calculated.landTaxAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сўм</td>
                                      </tr>
                                      <tr>
                                          <td>Суғурталаш харажатлари</td>
                                          <td>{{realEstate.comparisonNewIncome.coefficient.insurance | currency('', 2, { thousandsSeparator: ' ' })}} %</td>
                                          <td class="text-right">{{realEstate.comparisonNewIncome.calculated.insurance | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сўм</td>
                                      </tr>
                                      <tr class="section-start">
                                          <td colspan="4" class="text-center">Шартли узгарувчан харажатлар шу жумладан:</td>
                                      </tr>
                                      <tr>
                                          <td>Бошқарув харажатлари</td>
                                          <td>{{realEstate.comparisonNewIncome.coefficient.managementCosts}} %</td>
                                          <td class="text-right">{{realEstate.comparisonNewIncome.calculated.managementCostsAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сўм</td>
                                      </tr>
                                      <tr>
                                          <td>Коммунал харажатлар</td>
                                          <td></td>
                                          <td class="text-right">{{realEstate.comparisonNewIncome.calculated.utilityCosts | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сўм</td>
                                      </tr>
                                      <tr>
                                          <td>Ҳудудни сақлаш харажатлари</td>
                                          <td rowspan="3">{{realEstate.comparisonNewIncome.coefficient.expenseOthers}} %</td>
                                          <td rowspan="3" class="text-right">{{realEstate.comparisonNewIncome.calculated.expenseOthersAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td rowspan="3">сўм</td>
                                      </tr>
                                      <tr>
                                          <td>Жорий таъмирлаш ишлари учун харажатлар</td>
                                      </tr>
                                      <tr>
                                          <td>Алмаштириш харажатлари</td>
                                      </tr>
                                      <tr>
                                          <td>Хизмат кўрсатувчи ходимлар иш ҳақи ва унга солинадиган солиқлар</td>
                                          <td>{{realEstate.comparisonNewIncome.coefficient.salaryTaxes}} %</td>
                                          <td class="text-right">{{realEstate.comparisonNewIncome.calculated.salaryTaxesAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сўм</td>
                                      </tr>
                                      <tr>
                                          <td>Бошқа турдаги харажатлари</td>
                                          <td>5%</td>
                                          <td class="text-right">{{realEstate.comparisonNewIncome.calculated.securityCostsAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сўм</td>
                                      </tr>
                                      <tr class="section-start">
                                          <td colspan="4" class="text-center">Обеъкт қийматини капиталлаштириш ставкасида ҳисоб-китоб қилиш</td>
                                      </tr>
                                      <tr>
                                          <td style="font-weight: bold; color: #404040;">Хакикий даромад</td>
                                          <td></td>
                                          <td class="text-right" style="font-weight: bold; color: #404040;">{{realEstate.comparisonNewIncome.calculated.realIncome | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сўм</td>
                                      </tr>
                                      <tr>
                                          <td style="font-weight: bold; color: #404040;">Шартли ўзгармас харажатлар</td>
                                          <td></td>
                                          <td class="text-right" style="font-weight: bold; color: #404040;">{{totalFixedCostAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сўм</td>
                                      </tr>
                                      <tr>
                                          <td style="font-weight: bold; color: #404040;">Шартли узгарувчан харажатлар шу жумладан:</td>
                                          <td></td>
                                          <td class="text-right" style="font-weight: bold; color: #404040;">{{totalVariableCostAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сўм</td>
                                      </tr>
                                      <tr>
                                          <td style="font-weight: bold; color: #404040;">Соф даромад</td>
                                          <td class="text-right"></td>
                                          <td class="text-right" style="font-weight: bold; color: #404040;">{{realEstate.comparisonNewIncome.calculated.netIncome | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сўм</td>
                                      </tr>
                                      <tr>
                                          <td>Савдоларнинг бозор нархи (Sp)</td>
                                          <td></td>
                                          <td class="text-right" style="font-weight: bold; color: #404040;">{{(totalAnalogPrice / 3) | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сўм</td>
                                      </tr>
                                      <tr>
                                          <td>СОД ўртача (SOD)</td>
                                          <td></td>
                                          <td class="text-right" style="font-weight: bold; color: #404040;">
                                              {{(averageAnalogNetIncome / 3) | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                          <td>сўм</td>
                                      </tr>
                                      <tr>
                                          <td>Капиталлаштириш ставкаси % да (Ro)</td>
                                          <td class="text-center" style="font-weight: bold; color: #404040;">Ro = SOD/Sp</td>
                                          <td class="text-right" style="font-weight: bold; color: #404040;">{{realEstate.comparisonNewIncome.coefficient.capitalizePercent | currency('', 2, { thousandsSeparator: ' ' })}} %</td>
                                          <td>сўм</td>
                                      </tr>
                                      <tr class="bold-row">
                                          <td>Даромад ёндошувида объект киймати:</td>
                                          <td class="text-right"></td>
                                          <td class="text-right">{{realEstate.comparisonNewIncome.calculated.total | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сўм</td>
                                      </tr>
                                  </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-12">
                <div class="text-center">
                    <span class="no-data mt-5 mb-5">{{$t("messages.list.empty")}}</span>
                </div>
            </div>
        </div>
        <IncomeRentComparisonViewModal />
    </div>
</template>

<script>
    import IncomeRentComparisonViewModal from "./IncomeRentComparisonViewModal";
    export default {
        name: "NewRealEstateIncomeView",
        components: {IncomeRentComparisonViewModal},
        props: {
            realEstate: Object,
            owner: Object,
            approachIncome: {
                type:Boolean,
                default: false
            }
        },
        computed: {
            isIncomeValidData() {
                return this.approachIncome && this.realEstate.comparisonNewIncome
                    && this.realEstate.comparisonNewIncome.calculated && this.realEstate.comparisonNewIncome.coefficient;
            },
            isOwnerTypeLegal() {
                return !!(this.owner && this.owner.type && this.owner.type === 'Legal');
            },
            isOwnerTypePhysical() {
                return !!(this.owner && this.owner.type && this.owner.type === 'Physical');
            },
            isSoleTaxPayer() {
                let isSalesTax = false;
                if (this.owner && this.owner.soleTaxPayer && this.owner.soleTaxPayer === true) {
                    isSalesTax = true
                }
                return isSalesTax;
            },
            totalFixedCostAmount() {
                if (this.realEstate && this.realEstate.comparisonNewIncome && this.realEstate.comparisonNewIncome.calculated) {
                    const calculated = this.realEstate.comparisonNewIncome.calculated;
                    return (calculated.landTaxAmount ? calculated.landTaxAmount : 0) +
                        (calculated.propertyTaxAmount ? calculated.propertyTaxAmount : 0) +
                        (calculated.insurance ? calculated.insurance : 0)
                }
                return 0;
            },
            totalVariableCostAmount() {
                if (this.realEstate && this.realEstate.comparisonNewIncome && this.realEstate.comparisonNewIncome.calculated) {
                    const calculated = this.realEstate.comparisonNewIncome.calculated;
                    return (calculated.managementCostsAmount ? calculated.managementCostsAmount : 0) +
                        (calculated.utilityCosts ? calculated.utilityCosts : 0) +
                        (calculated.expenseOthersAmount ? calculated.expenseOthersAmount : 0) +
                        (calculated.salaryTaxesAmount ? calculated.salaryTaxesAmount : 0) +
                        (calculated.securityCostsAmount ? calculated.securityCostsAmount : 0)
                }
                return 0;
            },
            averageAnalogNetIncome() {
                return this.realEstate.comparisonNewIncome.analogs
                    .map((analog) => this.subAnalogNetIncome(analog))
                    .reduce((a, b) => a + b, 0)
            },
            totalAnalogPrice() {
                return this.realEstate.comparisonNewIncome.analogs
                    .map((analog) => this.subAnalogPrice(analog))
                    .reduce((a, b) => a + b, 0)
            },
            isRentComparison() {
                return this.realEstate && this.realEstate.comparisonNewIncome && this.realEstate.comparisonNewIncome.incomeRent
            }
        },
        methods: {
            subAnalogNetIncome(analog) {
                if (analog && analog.calculated && analog.calculated.realIncome && analog.totalCosts) {
                    return analog.calculated.realIncome - analog.totalCosts;
                }
                return 0;
            },
            subAnalogPrice(analog) {
                if (analog && analog.price && analog.price > 0) {
                    return analog.price;
                }
                return 0;
            },
            showIncomeRentComparisonModal() {
                this.$eventBus.$emit('showIncomeComparisonRentModal',this.realEstate)
            }
        }
    }
</script>

<style scoped>
    .comparison-table {
        font-size: 14px;
    }

    .comparison-table th {
        /*vertical-align: top;*/
        border: 1px solid #dee2e6;
        border-collapse: collapse;
        background-color: #E9FAFD;
    }
    .comparison-table td {
        border: 1px solid #dee2e6;
        border-collapse: collapse;
    }
    .comparison-table .percentage {
        margin: auto;
        width: 110px !important;
        display: inline-block;
    }
    .comparison-table .percentage div {
        width: 80px !important;
        float: left;
    }
    .comparison-table .percentage span {
        display: block;
        margin: 7px 5px;
        float: left;
    }
    .comparison-table .section-start td {
        background-color: #F3F3F3;
    }
    .comparison-table .section-start > td:first-child {
        font-weight: bold;
    }
</style>